import React from 'react';
import { IconButton } from '../../../../common/controls/Controls';
import { FileTextOutlined, QuestionCircleFilled } from '@ant-design/icons';
import { Flex, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ApplicationQuestions = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="application-questions-container">
      <Flex>
        {/*<Tooltip*/}
        {/*  title={*/}
        {/*    <span style={{ color: '#0e306d' }}>*/}
        {/*      {t('Blahoželanie k 35. výročiu FRI')}*/}
        {/*    </span>*/}
        {/*  }*/}
        {/*  color="#ffb81c"*/}
        {/*  skey="#ffb81c"*/}
        {/*>*/}
        {/*  <img*/}
        {/*    src="/images/torta2.svg"*/}
        {/*    alt={t('Torta k 35. výročiu FRI')}*/}
        {/*    style={{ width: '2em', marginLeft: '1em' }}*/}
        {/*    onClick={() => {*/}
        {/*      if (i18n.language === 'en') {*/}
        {/*        navigate('/congratulations');*/}
        {/*      } else {*/}
        {/*        navigate('/blahozelanie');*/}
        {/*      }*/}
        {/*    }}*/}
        {/*  />*/}
        {/*</Tooltip>*/}
        <Tooltip
          title={<span style={{ color: '#0e306d' }}>{t('Otázka k prihláške')}</span>}
          color="#ffb81c"
          skey="#ffb81c"
        >
          <IconButton
            icon={<FileTextOutlined style={{ fontSize: '2em' }} />}
            onClick={() => {
              if (i18n.language === 'en') {
                navigate('/application-question');
              } else {
                navigate('/otazka-k-prihlaske');
              }
            }}
          />
        </Tooltip>
        <Tooltip
          title={<span style={{ color: '#0e306d' }}>{t('Spýtajte sa nás')}</span>}
          color="#ffb81c"
          skey="#ffb81c"
        >
          <IconButton
            icon={<QuestionCircleFilled style={{ fontSize: '2em' }} />}
            onClick={() => {
              if (i18n.language === 'en') {
                navigate('/contact');
              } else {
                navigate('/kontakt');
              }
            }}
          />
        </Tooltip>
      </Flex>
    </div>
  );
};

export default ApplicationQuestions;
